import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { State } from '../../+state/selectors';
import { GeoCoderService } from '../../services/geo-coder.service';
import * as appStateActions from '../app-state/app-state.actions';
import { APP_STATE } from '../app-state/app-state.models';
import * as fromRoot from '../selectors';
import { GeoCoderActionTypes } from './geo-coder.actions';
import * as geoCoderAction from './geo-coder.actions';

@Injectable()
export class GeoCoderEffects {
  constructor(
    private actions$: Actions,
    private geoCoder: GeoCoderService,
    private store: Store<State>
  ) {}

  autocomplete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GeoCoderActionTypes.GET_AUTOCOMPLETE_RESULTS),
      map((action: geoCoderAction.GetAutocompleteResultsAction) => action.payload),
      withLatestFrom(this.store.select(fromRoot.getSearchContext)),
      switchMap(([payload, context]) =>
        this.geoCoder.autocomplete(payload, context).pipe(
          map(response => {
            if (response.length) {
              return new geoCoderAction.GetAutocompleteResultsSuccessAction(response);
            }
            const errorMessage = 'Unable to retrieve predicitions, try again';
            return new geoCoderAction.GetAutocompleteResultsFailAction(errorMessage);
          }),
          catchError(error => of(new geoCoderAction.GetAutocompleteResultsFailAction(error)))
        )
      )
    )
  );

  autocompleteFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GeoCoderActionTypes.GET_AUTOCOMPLETE_RESULTS_FAIL),
      map((action: geoCoderAction.GetAutocompleteResultsFailAction) => action.payload),
      map(() => new appStateActions.SetAppStateAction(APP_STATE.RESULTS_NOT_FOUND))
    )
  );

  // TODO: verify error handling

  getSelectedAddressDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(geoCoderAction.GeoCoderActionTypes.GET_SELECTED_ADDRESS_DETAILS),
      map((action: geoCoderAction.GetSelectedAddressDetailsAction) => action.payload),
      withLatestFrom(this.store.select(fromRoot.getSearchContext)),
      switchMap(([placeId, context]) =>
        this.geoCoder.getDetails(placeId, context).pipe(
          map(response => new geoCoderAction.GetSelectedAddressDetailsSuccessAction(response)),
          catchError(error => {
            const errorMessage = 'unable to get full address details';
            return of(new geoCoderAction.GetSelectedAddressDetailsFailAction(errorMessage));
          })
        )
      )
    )
  );
}
